import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';
import type { User } from '../types';

/**
 * Find an existing Talisman account by exact email, for inviting.
 *
 * Through the findTravellerByEmail callable, which returns only the public
 * profile. The client used to query the users collection itself, and the rule
 * that allowed it (`allow list: if isSignedIn()`) let any signed-in account list
 * EVERY profile — email, date of birth, home location, push tokens.
 *
 * The callable is deployed, so a lookup failure is surfaced to the inviter.
 * No client-side users collection query is permitted or useful now.
 */
export async function findTravellerByEmail(email: string): Promise<User | null> {
  const call = httpsCallable<{ email: string }, { found: boolean; user?: User }>(functions, 'findTravellerByEmail');
  const { data } = await call({ email });
  return data.found && data.user ? data.user : null;
}

export interface PendingTripInvitation {
  tripId: string; title: string; ownerId: string;
  destinations?: import('../../functions/src/travellerRoutePolicy.mjs').RouteVisit[];
  participation?: import('../../functions/src/travellerRoutePolicy.mjs').TripParticipation | null;
}
export async function getPendingInvitations(tripId?: string): Promise<PendingTripInvitation[]> {
  const call = httpsCallable<{ tripId?: string }, { invitations: PendingTripInvitation[] }>(
    functions, 'getPendingInvitations');
  return (await call(tripId ? { tripId } : {})).data.invitations;
}
